// extracted by mini-css-extract-plugin
export default {"item":"ContactPage_item__m6yOt","contact":"ContactPage_contact__iid0-","hr":"ContactPage_hr__cc3y8","title":"ContactPage_title__7Virs"};